import type { PartTypeInput, PartTypeView } from '@chukua/common';

export interface PartTypeFormValues {
  name: string;
  expectedLifeKm: number | null;
  expectedLifeDays: number | null;
}

export function toPartTypeFormValues(row?: PartTypeView): PartTypeFormValues {
  return { name: row?.name ?? '', expectedLifeKm: row?.expectedLifeKm ?? null, expectedLifeDays: row?.expectedLifeDays ?? null };
}

/** An empty field sends null, which is what clears a threshold on an edit. */
export function toPartTypeInput(values: PartTypeFormValues): PartTypeInput {
  return { name: values.name.trim(), expectedLifeKm: values.expectedLifeKm ?? null, expectedLifeDays: values.expectedLifeDays ?? null };
}
